import { create } from 'zustand';

const defaultFilterValue = {
  qs: null,
  object: null,
};

const initialState = {
  videoPageFilters: defaultFilterValue,
  collectionPageFilters: defaultFilterValue,
  collectionNewPageFilters: defaultFilterValue,
  userPageFilters: defaultFilterValue,
};

export const useTableFilterStore = create(set => ({
  ...initialState,
  setVideoPageFilter: videoPageFilters => set({ videoPageFilters }),
  setCollectionPageFilters: collectionPageFilters =>
    set({ collectionPageFilters }),
  setCollectionNewPageFilters: collectionNewPageFilters =>
    set({ collectionNewPageFilters }),
  setUserPageFilters: userPageFilters => set({ userPageFilters }),
}));
